/**
 * Theme toggle button — cycles Light → Dark → Auto.
 * Shows current mode as an icon, with a tooltip explaining the cycle.
 */
import React from 'react';
import { Sun, Moon, MonitorCog } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

export default function ThemeToggle({ compact = false }) {
  const { mode, effective, cycle } = useTheme();
  const Icon = mode === 'light' ? Sun : mode === 'dark' ? Moon : MonitorCog;
  const label = mode === 'auto' ? `Auto · ${effective}` : mode;
  return (
    <button
      data-testid="theme-toggle"
      onClick={cycle}
      title={`Theme: ${label} (click to cycle)`}
      className={`h-9 w-9 rounded-md border border-slate-200/70 dark:border-white/10
                  bg-white/70 dark:bg-white/[0.03] hover:border-[#8B3FC5] transition-colors
                  flex items-center justify-center`}
    >
      <Icon size={15} className="text-[#5E1F8B] dark:text-[#8B3FC5]"/>
      {!compact && (
        <span className="sr-only">Current theme: {label}</span>
      )}
    </button>
  );
}
